import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { FileText, Video, Presentation, FolderPlus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

const iconFor = (t) => t === "Video" ? Video : (t === "PPT" ? Presentation : FileText);

export default function MaterialsPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title:"", type:"PDF", subject:"", url:"" });
  const load = async () => setItems((await api.get("/materials")).data);
  useEffect(()=>{load()},[]);
  const create = async (e) => {
    e.preventDefault();
    await api.post("/materials", form);
    setOpen(false); toast.success("Material uploaded"); load();
  };
  return (
    <div>
      <PageHeader title="Study Materials" subtitle="PDFs, notes, videos and PPTs"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button className="btn-primary flex items-center gap-2" data-testid="add-material-btn"><FolderPlus size={16}/> Upload</button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Upload material</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <input required placeholder="Title" data-testid="material-title-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.title} onChange={e=>setForm({...form, title:e.target.value})}/>
                <div className="grid grid-cols-2 gap-2">
                  <select data-testid="material-type-select" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md bg-white" value={form.type} onChange={e=>setForm({...form, type:e.target.value})}>
                    {["PDF","Video","PPT","Assignment","EBook"].map(x=><option key={x}>{x}</option>)}
                  </select>
                  <input placeholder="Subject" data-testid="material-subject-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.subject} onChange={e=>setForm({...form, subject:e.target.value})}/>
                </div>
                <input placeholder="URL (optional)" data-testid="material-url-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md" value={form.url} onChange={e=>setForm({...form, url:e.target.value})}/>
                <DialogFooter><button className="btn-primary" data-testid="material-save-btn">Save</button></DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((m) => {
          const Icon = iconFor(m.type);
          return (
            <div key={m.id} className="linkedin-card p-4 flex gap-3 hover:border-[#0A66C2]" data-testid={`material-card-${m.id}`}>
              <div className="w-11 h-11 rounded-md bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center flex-shrink-0"><Icon size={20}/></div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-[#000000E6] truncate">{m.title}</div>
                <div className="text-xs text-[#00000099]">{m.subject} · {m.type}</div>
                <div className="text-[11px] text-[#00000066] mt-1">Uploaded by {m.uploaded_by || "System"}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
